<template>
  <el-container>
    <el-dialog
        :visible.sync="dialogVisible">
      <div
          style="width: 100%;height: 450px;padding-top:30px;display: flex;flex-direction: column;flex-wrap:wrap;justify-content:flex-start;align-items:center;">
        <el-input placeholder="请输入内容" v-model="username">
          <template slot="prepend">账号</template>
        </el-input>
        <el-input placeholder="请输入内容" v-model="password" type="password">
          <template slot="prepend">密码</template>
        </el-input>
        <el-button type="primary" @click="userLogin">登录</el-button>
      </div>
    </el-dialog>
    <el-container>
      <el-aside width="200px">
        <el-menu :default-openeds="['1', '2']" router>
          <el-menu-item index="/">首页</el-menu-item>
          <el-submenu index="1">
            <template slot="title"><i class="el-icon-message"></i>功能</template>
            <el-menu-item index="ResetIp">切换ip</el-menu-item>
            <el-menu-item index="FastFormat">快速排版</el-menu-item>
            <el-menu-item index="CoverGenerator">封面制作</el-menu-item>
            <el-menu-item index="DyAvatarGenerator">抖音头像</el-menu-item>
            <el-menu-item index="WxGroup">微信群</el-menu-item>
          </el-submenu>
          <el-submenu index="2">
            <template slot="title"><i class="el-icon-message"></i>存图帮管理</template>
            <el-menu-item index="OrderRecord">订单查询</el-menu-item>
            <el-menu-item index="UseRecord">使用记录</el-menu-item>
            <el-menu-item index="CtbUser">用户查询</el-menu-item>
            <el-menu-item index="ServerLog">日志查询</el-menu-item>
          </el-submenu>
        </el-menu>
        <div style="width:120px;">
          <el-button v-if="token == null" round size="small" type="primary" @click="dialogVisible = true">登录</el-button>
          <div v-else style="width: 100%;height: 100%;">
            <el-popover
                placement="bottom"
                width="100"
                trigger="hover">
              <div style="text-align: left; margin: 0">
                <el-link :underline="false" style="width: 100%;height: 30px;margin-top: 10px;justify-content: left;"
                         @click="userLogout"><i style="font-size: 14px;" class="iconfont icontuichudenglu"></i>退出登录
                </el-link>
              </div>
              <el-link :underline="false" slot="reference"
                       style="font-size:14px;line-height: 28px;height: 28px;margin-left: 30px;">个人中心<i
                  class="el-icon-caret-bottom"></i></el-link>
            </el-popover>

          </div>
        </div>
      </el-aside>
      <el-main>
        <router-view id="content"/>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import {mapState, mapMutations} from "vuex";

export default {
  name: "App",
  data() {
    return {
      activeIndex: 0,
      select: 1,
      urlInput: "",
      username: "",
      password: "",
      dialogVisible: false,
      useOutDialogVisible: false,
      buyVipDialogVisible: false,
      contactServiceDialogVisible: false,
      useTutorialDialogVisible: false,
      warningDialogVisible: false,
      warningDialogTitle: null,
      warningDialogContent: null,
      loginCodeUrl: null,
      payCodeUrl: null,
      expireTime: null,
      changeIpLoading: false,
      isIndex: true,
      deviceList: [],
    }
  },
  created() {
    //created
  },
  mounted() {

  },
  computed: {
    ...mapState("ui", ["showHeaderBar", "showBottomNav", "transBackground"]),
    ...mapState("user", ["token"]),
  },
  methods: {
    userLogin() {
      let that = this;
      this.$api
          .post("/CwHelper/admin/login", {
            username: that.username,
            password: that.password
          })
          .then(response => {
            if (response.data.resultCode === 0) {
              that.setLogin(response.data);
              that.$message({
                message: '登录成功',
                type: 'success',
                duration: 1000,
                showClose: true
              });
            } else {
              that.$message({
                message: '登录失败',
                type: 'success',
                duration: 1000,
                showClose: true
              });
            }
            that.dialogVisible = false;
          })
          .catch(error => {
            that.$message({
              message: '登录失败',
              type: 'success',
              duration: 1000,
              showClose: true
            });
            that.dialogVisible = false;
          });
    },
    //用户退出登录
    userLogout() {
      this.setLogout();
    },
    ...mapMutations("user", {
      setLogin: "login",
      setLogout: "logout",
    }),
  }
};
</script>

<style>

.el-header, .el-footer {
  background-color: #B3C0D1;
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: #D3DCE6;
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  min-height: unset !important;
  background-color: #E9EEF3;
  color: #333;
  text-align: start !important;
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  font: inherit;
  vertical-align: baseline;
}

/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
  display: block;
}

body {
  line-height: 1;
}

ol, ul {
  list-style: none;
}

blockquote, q {
  quotes: none;
}

blockquote:before, blockquote:after,
q:before, q:after {
  content: '';
  content: none;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}
</style>
